import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GetDetailProject } from "../../api/projectapi";
import CsvBtn from "../../components/CsvBtn/CsvBtn";
import Emty from "../../components/Emty/Emty";
import {
  ApprvCard,
  detailtype,
  MeetupBasicDataType,
  PaymentCard,
  ProjectBasicDataType,
} from "../../interface/interface";
import {
  formatDate,
  PaymentStateForm,
  PaymnetDetailForm,
  PrjtCategory,
} from "../../lib/lib";
import "./css/index.css";

const headers = [
  "아이디",
  "닉네임",
  "이메일",
  "실명",
  "번호",
  "결제날짜",
  "결제상태",
  "결제금액",
];

type LocType = {
  state: PaymentCard;
};

function PaymentList() {
  const { state } = useLocation() as LocType;
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [type, settype] = useState<"pay" | "refund" | undefined>(undefined);
  const [data, setData] = useState<ApprvCard[]>([]);
  const [PrjtData, setPrjtData] = useState<
    MeetupBasicDataType | ProjectBasicDataType | undefined
  >(undefined);
  const __nav = useCallback(
    (type: ApprvCard) => {
      navigate(`/payment/detail`, {
        state: type,
      });
    },
    [navigate]
  );

  const getCsvData = useCallback((): Promise<any> => {
    return new Promise((resolve, reject) => {
      resolve(
        data.map(
          ({
            login_id,
            login_nm,
            rcrt_usr_name,
            rcrt_usr_phone,
            paym_amt,
            paym_at,
            rcrt_paysts_cd,
            usr_email,
          }) => {
            return [
              login_id,
              login_nm,
              usr_email,
              rcrt_usr_name,
              rcrt_usr_phone,
              formatDate(paym_at, "-"),
              rcrt_paysts_cd === "pay_suss"
                ? "결제성공"
                : rcrt_paysts_cd === "pay_fail"
                ? "결제실패"
                : rcrt_paysts_cd === "ref_req"
                ? "환불요청"
                : rcrt_paysts_cd === "ref_res"
                ? "환불완료"
                : rcrt_paysts_cd === "pay_wait"
                ? "결제대기"
                : rcrt_paysts_cd === "pay_canl"
                ? "결제취소"
                : "",
              paym_amt,
            ];
          }
        )
      );
    });
  }, [data]);

  useEffect(() => {
    if (state) {
      GetDetailProject(state.prjt_id).then(({ state, data }) => {
        if (state) {
          setData(data.payList);
          setPrjtData(data);
        }
      });
    }
    return () => {};
  }, [state]);

  return (
    <main className="paymentlist">
      <div className="wrapper">
        <div className="header">
          <Link to="/payment">
            <img
              src="/assets/common/rightarrow.svg"
              className="img"
              alt=""
            ></img>
          </Link>
          <div className="title">결제리스트</div>
        </div>
        {state && PrjtData ? (
          <div className="main">
            <div className="main_left">
              <div
                className="imagebox"
                style={{ backgroundImage: `url(${PrjtData.prjt_thumbnail})` }}
              />
              <div className="title">{state.prjt_nm}</div>
              <div className="line"></div>
              <div className="sub">
                <div className="title">카테고리</div>
                <div className="box">
                  {PrjtData.prjt_type_cd === "mtup"
                    ? PrjtData.mtup_typ === "OFFLINE"
                      ? "대면"
                      : "비대면"
                    : PrjtCategory[
                        PrjtData.prjt_ctg_cd as keyof typeof PrjtCategory
                      ]}
                </div>
              </div>
              <div className="sub">
                <div className="title">모집일정</div>
                <div className="sub">
                  {formatDate(state.rcrt_apply_st_at, "-")}~{""}
                  {formatDate(state.rcrt_apply_en_at, "-")}
                </div>
              </div>
              <div className="sub">
                <div className="title">팀플시작</div>
                <div className="sub">
                  {state.prjt_apply_st_at
                    ? formatDate(state.prjt_apply_st_at, "-")
                    : "미정"}
                </div>
              </div>
              {PrjtData.prjt_type_cd === "prjt" ? (
                <div className="sub">
                  <div className="title">모집분야</div>
                  <div className="sub">{PrjtData.rcrt_nm_agg}</div>
                </div>
              ) : undefined}
              <div className="sub">
                <div className="title2">팀플리더</div>
                <div className="sub">{state.leadr_usr_nm}</div>
              </div>

              <div className="paybox">
                <div className="sub">
                  <div className="title">결제성공</div>
                  <div className="number1">{state.paym_succ_cnt}건</div>
                </div>
                <div className="sub">
                  <div className="title">결제취소</div>
                  <div className="number2">{state.paym_can_cnt}건</div>
                </div>
                <div className="sub">
                  <div className="title">결제실패</div>
                  <div className="number3">{state.paym_ret_cnt}건</div>
                </div>
              </div>
            </div>
            <div className="main_right">
              <div className="title">
                <div className="left">
                  <img
                    src="/assets/common/vector.svg"
                    className="img"
                    alt=""
                  ></img>
                  결제 리스트
                </div>
                <div className="right">
                  <div className="type-box-wrapper">
                    <div className={`type_box ${isOpen ? "open" : ""}`}>
                      <button
                        className="now"
                        onClick={() => {
                          setIsOpen(!isOpen);
                        }}
                      >
                        <div className="type">
                          {" "}
                          {type
                            ? type === "pay"
                              ? "결제 유형"
                              : "환불 유형"
                            : "상태별"}
                        </div>
                        <img
                          className="buttontype"
                          src="/assets/common/button.svg"
                          alt=""
                        ></img>
                      </button>

                      <button
                        onClick={() => {
                          setIsOpen(false);
                        }}
                      >
                        결제 유형
                      </button>
                      <button
                        onClick={() => {
                          setIsOpen(false);
                        }}
                      >
                        환불 유형
                      </button>
                    </div>
                  </div>
                  {PrjtData ? (
                    <CsvBtn
                      title={`${PrjtData.prjt_nm} 결제 리스트`}
                      getCsvData={getCsvData}
                      headers={headers}
                    />
                  ) : undefined}
                </div>
              </div>
              <div className="sub">
                <div className="menu">
                  <div className="name1">아이디</div>
                  <div className="name6">닉네임</div>
                  <div className="name2">번호</div>
                  <div className="name3">실명</div>
                  <div className="name4">결제일</div>
                  <div className="name5">상태</div>
                </div>
              </div>
              <div className="list">
                {data.length > 0 ? (
                  data.map((item, index) => {
                    const type = PaymentStateForm(
                      PrjtData.prjt_type_cd,
                      PrjtData.prjt_sts_cd,

                      item.apprv_sts_cd,
                      item.apply_sts_cd,
                      item.rcrt_paysts_cd
                    );
                    return (
                      <div key={index} className={`box ${type.type}`}>
                        <div className="name">{item.login_id}</div>
                        <div className="name">{item.login_nm}</div>
                        <div className="email">{item.rcrt_usr_phone}</div>
                        <div className="team">{item.rcrt_usr_name}</div>
                        <div className="registration">
                          {item.paym_at ? formatDate(item.paym_at, "-") : "-"}
                        </div>
                        <div className="situation">{type.text}</div>
                        <div
                          className="list"
                          onClick={() => {
                            __nav(item);
                          }}
                        >
                          상세보기
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <Emty />
                )}
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
    </main>
  );
}

export default PaymentList;
